import { useTranslation } from 'react-i18next'
import { FullscreenModal } from '@/components/global/FullscreenModal/FullscreenModal'
import { Button } from '@/components/priority/Button/Button'
import { Flex } from '@/components/priority/Flex/Flex'
import { Text } from '@/components/priority/Text/Text'

type PrintImageQualityModalProps = {
  show: boolean
  onClose: () => void
  onAcknowledge?: () => void
  threshold: number
  showAcknowledgeButton?: boolean
}

export const PrintImageQualityModal = ({
  show,
  onClose,
  onAcknowledge,
  threshold,
  showAcknowledgeButton = false,
}: PrintImageQualityModalProps) => {
  const { t } = useTranslation()

  const handleAcknowledge = () => {
    if (onAcknowledge) {
      onAcknowledge()
    }
    onClose()
  }

  return (
    <FullscreenModal show={[show, onClose]} hideClose={false}>
      <Flex
        height="300px"
        width="600px"
        column
        center
        gap="32px"
        padding="0 32px"
      >
        <Flex gap="12px" column align="center">
          <Flex gap="12px" align="center">
            <Text size="32px">⚠️</Text>
            <Text weight="500" size="24px" align="center">
              {t('printQualityModal.title')}
            </Text>
          </Flex>
          <Flex gap="12px" column align="center">
            <Text width="500px" align="center">
              {showAcknowledgeButton
                ? t('printQualityModal.message', { threshold })
                : t('printQualityModal.pageLoadMessage', { threshold })}
            </Text>
            <Text width="500px" align="center" weight="500" size="14px">
              {showAcknowledgeButton
                ? t('printQualityModal.notice')
                : t('printQualityModal.pageLoadNotice')}
            </Text>
          </Flex>
        </Flex>
        <Flex gap="12px">
          {showAcknowledgeButton ? (
            <>
              <Button
                default
                onClick={onClose}
                aria-label={t('printQualityModal.closeButtonAriaLabel')}
                data-testid="print-quality-modal-close"
              >
                {t('printQualityModal.closeButton')}
              </Button>
              <Button
                primary
                onClick={handleAcknowledge}
                aria-label={t('printQualityModal.acknowledgeButtonAriaLabel')}
                data-testid="print-quality-modal-acknowledge"
              >
                {t('printQualityModal.acknowledgeButton')}
              </Button>
            </>
          ) : (
            <Button
              primary
              onClick={onClose}
              aria-label={t('printQualityModal.closeButtonAriaLabel')}
              data-testid="print-quality-modal-close"
            >
              {t('printQualityModal.closeButton')}
            </Button>
          )}
        </Flex>
      </Flex>
    </FullscreenModal>
  )
}
